import { useEffect, useState } from 'react';

const basePath = __BASE_PATH__.split('/').filter(Boolean).join('/');
const pathPrefix = basePath ? `/${basePath}` : '';

export default function GoogleAuthCallbackPage() {
  const [status, setStatus] = useState<'processing' | 'success' | 'error'>('processing');
  const [detail, setDetail] = useState('');

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const accessToken = params.get('access_token');
    const error = params.get('error');
    const errorDescription = params.get('error_description') || '';

    try {
      if (window.opener && !window.opener.closed) {
        if (accessToken) {
          window.opener.postMessage(
            { type: 'GOOGLE_OAUTH_SUCCESS', accessToken },
            window.location.origin,
          );
          setStatus('success');
          setDetail('Autorização concluída! Esta janela será fechada automaticamente.');
          setTimeout(() => window.close(), 800);
        } else {
          window.opener.postMessage(
            { type: 'GOOGLE_OAUTH_ERROR', error: error || 'no_token', errorDescription },
            window.location.origin,
          );
          setStatus('error');
          setDetail(errorDescription || error || 'Não foi possível obter o token de acesso.');
          setTimeout(() => window.close(), 3000);
        }
      } else {
        // Not opened as popup — redirect back to contacts page
        // window.close() doesn't work on main tabs, so we redirect instead
        if (accessToken) {
          sessionStorage.setItem('google_oauth_token', accessToken);
          sessionStorage.setItem('google_oauth_timestamp', String(Date.now()));
          window.location.href = `${window.location.origin}${pathPrefix}/contacts?googleImport=1`;
        } else {
          const errMsg = errorDescription || error || 'Falha na autorização';
          sessionStorage.setItem('google_oauth_error', errMsg);
          sessionStorage.setItem('google_oauth_error_detail', errorDescription || '');
          window.location.href = `${window.location.origin}${pathPrefix}/contacts?googleImportError=1`;
        }
      }
    } catch (err: unknown) {
      setStatus('error');
      setDetail('Erro inesperado ao processar resposta do Google.');
    }
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-50">
      <div className="text-center p-8 max-w-md">
        {status === 'processing' && (
          <>
            <div className="w-12 h-12 rounded-full border-[3px] border-background-200 border-t-primary-500 animate-spin mx-auto mb-4" />
            <p className="text-sm font-medium text-foreground-700">Processando autorização...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-line text-2xl text-emerald-600" />
            </div>
            <p className="text-sm font-medium text-foreground-700">{detail}</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
              <i className="ri-error-warning-line text-2xl text-red-500" />
            </div>
            <p className="text-sm font-semibold text-foreground-900 mb-1">Erro na autorização</p>
            <p className="text-xs text-foreground-500">{detail}</p>
            <button
              onClick={() => window.close()}
              className="mt-5 px-4 py-2 text-sm font-medium text-foreground-600 bg-white border border-background-200 rounded-lg hover:bg-background-50 transition-colors cursor-pointer"
            >
              Fechar janela
            </button>
          </>
        )}
      </div>
    </div>
  );
}